<template>
  <button
    :class="classList"
    :disabled="disabled"
    :aria-label="accessibilityLabel"
    :title="accessibilityLabel"
    @click.stop="handleClick"
  >
  <div :class="classListWrapper">
      <template v-if="icon">
        <vue-feather :type="icon" data-icon :class="classListIcon"></vue-feather>
      </template>
      <template v-else>
        <slot name="iconSvg" />
      </template>
      <span v-if="label" :class="classListLabel">{{ label }}</span>
    </div>
      <transition name="transition-fade-pop">
        <Loader
          v-show="loading"
          data-loader
          visible
          class="absolute inset-0 z-20"
        />
      </transition>
    </button>
</template>

<script>
import Loader from '@vuedir/components/Loader'
import VueFeather from 'vue-feather';
/**
 * IconButton.vue
 */
export default {
  components: {
    Loader,
    VueFeather
  },

  props: {
    label: {
      type: String,
      default: null,
    },

    icon: {
      type: String,
      required: false,
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    active: {
      type: Boolean,
      default: false,
    },

    loading: {
      type: Boolean,
      default: false,
    },

    size: {
      type: String,
      default: 'medium',
      validator: (value) => ['small', 'medium', 'large'].indexOf(value) !== -1,
    },

    inverted: {
      type: Boolean,
      default: false,
    },

    fixed: {
      type: Boolean,
      default: true,
    },

    position: {
      type: String,
      default: 'relative',
    },

    accessibilityLabel: {
      type: String,
      default: null,
    },
  },

  emits: ['click'],

  data () {
    return {}
  },

  computed: {
    classList () {
      return [
        'flex flex-col justify-center items-center transition-all select-none focus:outline-none',
        this.position,
        this.fixed ? '' : 'flex-1',
        this.size === 'small' ? 'w-8 h-8' : '',
        this.size === 'medium' ? 'w-14 h-14' : '',
        this.size === 'large' ? 'w-16 h-16' : '',
        this.disabled ? 'text-gray-300 cursor-not-allowed' : 'hover:bg-blue-50 hover:text-blue-500',
        this.inverted ? 'text-white': 'text-black',
        this.active ? 'text-blue-500 bg-blue-50' : '',
      ]
    },

    classListWrapper () {
      return [
        'relative flex flex-col justify-center items-center transition-all',
        this.loading ? 'opacity-0' : 'opacity-100',
      ]
    },

    classListLabel () {
      return [
        'text-xs text-gray-700 leading-tight group-hover:text-blue-500 group-focus:text-blue-500 transition-color',
        this.active ? 'text-blue-500' : '',
      ]
    },

    classListIcon () {
      return [
        this.size === 'small' ? 'w-4 h-4' : '',
        this.size === 'medium' ? 'w-5 h-5' : '',
        this.size === 'large' ? 'w-6 h-6' : '',
      ]
    },
  },

  methods: {
    handleClick () {
      this.$emit('click')
    },
  },
}
</script>
